<template>
  <div class="menu dinline-block vtop fs14 pl35">
    <div class="tleft pl5 pr10 tc6 pb15">
      <div class="fs24 mr5 dinline-block prelative">
        <span class="img-schange img-bg dinline-block vbottom"></span>
        {{id>=0?menu[pid]['children'][id]['name']:menu[pid]['name']}}
      </div>
      <div class="pt10 fr">
        当前位置:
        <span v-if="id>=0">{{menu[pid]['name']}} > </span>
        <span>{{id>=0?menu[pid]['children'][id]['name']:menu[pid]['name']}}</span>
      </div>
    </div>
    <div class="notices border-red tleft pt15 pl15 pr10 pb20">
      <template v-if="list">
        <div class="sdiv pl5 cpointer fs16 lh18 ofhidden prelative mb5 pl20 pr5" v-for="(item,index) in list" @click="goDetail(item.id)">
          {{item.title}}
        </div>
      </template>
    </div>
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="$route.query.category_id"/>
  </div>
</template>

<script>
import Pagec from "../../components/un_index/Page";

export default {
  name: "list",
  data(){
    return {
      id:'',
      pid:'',
      perPage:20,
      page:1,
      list:[],
      menu:[],
      msg:'加载中……',
      total:0,
    }
  },
  components:{
    Pagec
  },
  updated() {
  },
  created() {
    this.id = this.$route.query.id
    this.pid = this.$route.query.pid
  },
  mounted() {
    this.getData();
  },
  methods:{
    goDetail(article_id){
      var query = this.$route.query;
      query.article_id = article_id;
      this.$router.push({path:'/enroll/article/detail',query:query});
    },
    clearList(){
    },
    getData(page){
      console.log(1)
      this.page = page;
      var getParam = {}
      var id = this.$route.query['category_id']
      getParam['category_id'] = id
      getParam['perPage'] = this.perPage
      getParam['page'] = this.page
      this.$request.get('get-enroll-columns', [], response => {
        if (response.status == 200) {
          this.menu = response.data;
        } else {
          console.error("获取数据失败");
        }
      },error => {
        console.log(error)
      })
      this.$request.get('recruit-article/list',getParam,response => {
        if(response.status == 200 && response.data.data.data.length > 0){
          let res = response.data.data.data
          this.list = res
          this.total = response.data.data.total
        }else{
          this.msg = '无数据';
        }
      },error => {
        console.log(error)
      })
    },
  },
  watch:{
    $route:{
      deep:true,
      handler:function($n,$o){
        this.id = $n.query.id
        this.pid = $n.query.pid
        this.list = []
        this.page = 1
      }
    },
  },
}
</script>

<style scoped>
  .menu{width: 930px;margin-top:0;}
  .img-media{background: url(../../assets/images/scn1.png) no-repeat -60px -28px;}
  .img-sinfo{background: url(../../assets/images/scn1.png) no-repeat -60px -195px;}
  .img-schange{background: url(../../assets/images/scn1.png) no-repeat -60px -280px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-sproblem{background: url(../../assets/images/scn1.png) no-repeat -60px -448px;}
  .img-sdown{background: url(../../assets/images/scn1.png) no-repeat -60px -528px;}
</style>



// WEBPACK FOOTER //
// src/pages/enroll/list.vue